<template>
    <div>
        <el-dialog
        class="day-detail"
        :title="'查看明细'"
        :visible.sync="flag"
        width="640px"
        :close-on-click-modal="false"
        @close="btnEvent"
        height="600px">
            <div>
               <el-form>
                    <div class="form-row">
                       <el-form-item label="客户单号">
                            <el-input v-model="formobj.ettaSoNo" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="运输单号" class="m-l">
                                <el-input v-model="formobj.ettaNo" :disabled="true"></el-input>
                        </el-form-item>
                   </div>
                   <div class="form-row">
                       <el-form-item label="发车单号">
                            <el-input v-model="formobj.ettaDoNo" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="车牌号" class="m-l">
                                <el-input v-model="formobj.licensePlateNumber" :disabled="true"></el-input>
                        </el-form-item>
                   </div>
                   <div class="form-row">
                       <el-form-item label="司机名称">
                            <el-input v-model="formobj.driverName" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="司机手机号码" class="m-l">
                                <el-input v-model="formobj.contactMobile" :disabled="true"></el-input>
                        </el-form-item>
                   </div>
                   <div class="form-row">
                       <el-form-item label="线路从">
                            <el-input v-model="formobj.from" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="线路到" class="m-l">
                                <el-input v-model="formobj.to" :disabled="true"></el-input>
                        </el-form-item>
                   </div>

                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="btnEvent">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { filePreview } from '@/utils/filePreview.js';
import { customerDailyAssessment } from '../../../lsrm/api/achievements/daylyAssessment.js';
import { moduleFile } from '../../../lsrm/api/annoMana.js';
export default {
    props: {
        detialFlag: {
            type: Boolean
        },
        title: {
            type: String
        },
        showFlagType: {
            type: Number
        },
        reasonRow: {
            type: Object,
            default() {
                return {};
            }
        },
        selectItem: {
            type: Array
        }
    },
    data() {
        return {
            flag: false,
            moduleFileInfo: [],
            formobj: {}
        };
    },
    methods: {
        btnEvent() {
            this.flag = false;
            this.$emit('closeDay', false);
        },
        actionFn(row, type, index) {
            if (type === '2') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '1') {
                filePreview(row);
            } else {
                this.moduleFileInfo.splice(index, 1);
            }
        },
        queryFiles(row) {
            moduleFile({ moduleNo: row.derateCode, moduleTypes: ['02'] }).then(
                res => {
                    if (res && +res.code === 0) {
                        this.fileTableData = res.data ? res.data.list : [];
                    }
                }
            );
        }
    },
    watch: {
        detialFlag(val) {
            this.flag = val;
            this.queryFiles(this.reasonRow);
            customerDailyAssessment(this.reasonRow.id).then(res => {
                if (res && +res.code === 0) {
                    this.formobj = res.data;
                    this.formobj.from = this.formobj.fromProvince + this.formobj.fromCity + this.formobj.fromDistrict || '';
                    this.formobj.to = this.formobj.toProvince + this.formobj.toCity + this.formobj.toDistrict || '';
                }
            });
        }
    }
};
</script>

<style lang="less">
.day-detail {
    .el-input__inner {
        width: 170px !important;
    }
    .number {
        color: #00BCBF;
        cursor: pointer;
    }
    .BidDialog-tip {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .info {
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .el-table__row {
        font-size: 12px;
    }
    .upload-enclosure {
        width:100%;
        display: flex;
        justify-content: space-between;
        margin: 10px 0
    }
    .title {
        font-size: 14px;
    }
    .upload_enclosure_top {
        color: #00BCBF;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .el-dialog__footer {
        border-top: 1px solid #eee;
    }
    .m-t10 {
        margin-top: 10px;
    }
    .tab-box {
        margin-top:10px;width: 100%;
    }
    .span-button {
        margin-left: 10px;
    }
    .el-form-item {
        display: flex;
        margin-bottom: 0;
    }
    .form-row {
        display: flex;
    }
    .el-form-item__label {
        width: 108px !important;
    }
    .m-l {
        margin-left: 60px;
    }
}
</style>